export type StatItem = { label: string; desc: string };
export type MechanicItem = { title: string; desc: string };
export type StepItem = { step: string; title: string; desc: string };

export const SECTION_WRAP = 'mx-auto w-full max-w-6xl px-4 md:px-6';
export const NARROW_WRAP = 'mx-auto w-full max-w-4xl px-4 md:px-6';
